/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from "react";

import { Card, CardBody, Spinner } from "reactstrap";

import "./style.scss";

import "react-perfect-scrollbar/dist/css/styles.css";

import HorizontalTimeline from "../ProcessData/HorizontalTimeline";

//i18n
import { withTranslation, useTranslation } from "react-i18next";

import { useSelector } from "react-redux";

import { showToast } from "../../../../functions/utils";

const FormsData = ({ consumerId, chatId, handleRefresh, data, ...props }) => {
  const { t } = useTranslation();

  const status = useSelector(
    (state) => state.ConsumerTickets.status?.[consumerId]
  );

  useEffect(() => {
    if (status?.error) {
      showToast("error", t(status.error));
    }
  }, [status]);

  return (
    <>
      <div>
        <div className="information">
          <div>
            <span className="input-ticket">{t("Total")}: </span>
            <span className="label-ticket">{data?.count ?? "-"} </span>
          </div>
          <button
            className={`conversation-header-button-wrapper small-light mx-2`}
            onClick={handleRefresh}
          >
            <i
              className={`bx bx-refresh bx-xs mr-0 align-self-center header-button-icons header-button-refresh ${
                status?.loading ? "loading-spinning" : ""
              }`}
            />
          </button>
        </div>
        <div className="divider" />
        {data?.tickets?.length ? (
          <>
            {data.tickets.map((ticket, index) => (
              <div key={index}>
                <Card className="mt-2 pointer">
                  <CardBody className="p-0 ">
                    <div class="pt-1 border">
                      <HorizontalTimeline
                        processsData={ticket?.processData}
                        invisibleSLA
                      />
                    </div>
                  </CardBody>
                </Card>
              </div>
            ))}
          </>
        ) : null}

        {!data?.tickets?.length && !status?.loading && (
          <>
            {status?.error ? (
              <div className="information">{t(status.error)}</div>
            ) : (
              <div className="information">{t("No tickets found")}</div>
            )}
          </>
        )}

        {!data?.tickets?.length && status?.loading && (
          <div className="w-100 pb-3 text-center">
            <Spinner
              animation="border"
              size="sm"
              className="spinner my-2 smallSpinner"
            />
          </div>
        )}
      </div>
    </>
  );
};
export default withTranslation()(React.memo(FormsData));
